// src/store.js
import { configureStore} from '@reduxjs/toolkit';
import categoriesReducer from './slices/categoriesReducer';
import affiliateReducer from './slices/affiliatesReducer';
import dishesReducer from './slices/dishesReducer';
import adminReducer from './slices/adminReducer';
import patientProfilesReducer from './slices/patientProfilesReducer';
import mealsReducer from './slices/mealsReducer';
import patientMealInstancesReducer from './slices/patientMealInstancesReducer';

const store = configureStore({
  reducer: {
    affiliate: affiliateReducer,
    categories: categoriesReducer,
    dishes: dishesReducer,
    admin: adminReducer,
    patientProfiles: patientProfilesReducer,
    meals: mealsReducer,
    patientMealInstances: patientMealInstancesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore paths that may contain non-serializable values if necessary
        ignoredPaths: ['categories.category.headers'],
        ignoredActions: ['categories/fetchCategoryById/fulfilled'],
      },
    }),
});

export default store;
